import { store } from "@store/store";
import { clearUser } from "@store/slices/userSlice";
import { resetNotifications } from "@store/slices/notificationSlice";
import { clearEmbedAlternateChrome } from "@store/slices/externalPortalSlice";
import { clearAuthData } from "@utils/auth";
import { resetUnauthorizedFlag } from "@config/axios/axios.config";
import { clearRegistrationSessionState } from "@utils/clearRegistrationSessionState";

export type LogoutSessionOptions = {
	/** Keep axios 401 request block active (session expiry handler). */
	preserveUnauthorizedBlock?: boolean;
};

/**
 * Clears auth storage and resets Redux the same way as confirming logout in the UI.
 * Used from this tab’s logout flow and from other tabs (BroadcastChannel / storage).
 */
export function logoutSessionInStore(options?: LogoutSessionOptions): void {
	if (!options?.preserveUnauthorizedBlock) {
		resetUnauthorizedFlag();
	}

	const dispatch = store.dispatch;
	dispatch(clearUser());
	clearRegistrationSessionState(dispatch);
	dispatch(resetNotifications());
	dispatch(clearEmbedAlternateChrome());

	clearAuthData();
}
